import { render } from "./AddNewUnit.vue?vue&type=template&id=d9585a3c&scoped=true"
import script from "./AddNewUnit.vue?vue&type=script&lang=js"
export * from "./AddNewUnit.vue?vue&type=script&lang=js"

import "./AddNewUnit.vue?vue&type=style&index=0&id=d9585a3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9585a3c"]])

export default __exports__